import React from 'react';

import PropTypes from 'prop-types';

import { FontBase } from 'const';

import { pxToRem } from 'utils/scss';

import Typeface, { TypefaceInterface } from './index';

const baseConfig = {
  color: 'unset',
  fontFamily: 'opensans',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: 1,
  letterSpacing: 'unset',
  fontSize: FontBase,
  cursor: 'inherit'
};

const types = {
  1: {
    ...baseConfig
  },
  2: {
    ...baseConfig,
    fontWeight: 400
  },
  3: {
    ...baseConfig,
    fontWeight: 500
  },
  4: {
    ...baseConfig,
    fontWeight: 600
  },
  5: {
    ...baseConfig,
    fontWeight: 700
  },
  light: {
    ...baseConfig,
    fontWeight: 300
  },
  medium: {
    ...baseConfig,
    fontWeight: 500
  },
  bold: {
    ...baseConfig,
    fontWeight: 700
  },
  chargerTitle: {
    ...baseConfig,
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 1.33
  },
  resumeLabel: {
    ...baseConfig,
    fontSize: 14,
    color: 'darkGray'
  },
  detailTitle: {
    ...baseConfig,
    fontSize: 18,
    fontWeight: 700
  },
  errorLabel: {
    ...baseConfig,
    fontSize: 12,
    color: 'redError'
  },
  errorLabelLink: {
    ...baseConfig,
    fontSize: 12,
    color: 'mainBlue'
  },
  numberTitle: {
    ...baseConfig,
    fontSize: 14,
    lineHeight: 1.14,
    color: 'grayText'
  },
  peopleTitle: {
    ...baseConfig,
    fontSize: 24,
    fontWeight: 'bold',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterspacing: 'normal',
    color: 'black.one'
  },
  addButton: {
    ...baseConfig,
    fontSize: 14,
    color: 'statusGreen',
    fontWeight: 700
  },
  blueLabel: {
    ...baseConfig,
    color: 'mainBlue'
  },
  showLabel: {
    ...baseConfig,
    fontSize: 12,
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'black.six'
  },
  highlightText: {
    ...baseConfig,
    mixBlendMode: 'luminosity',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.71,
    fontStretch: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'black.one'
  },
  title: {
    ...baseConfig,
    fontSize: 24,
    fontWeight: 'bold',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterspacing: 'normal',
    color: 'black.one'
  },
  description: {
    ...baseConfig,
    fontSize: 16,
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'black.one'
  },
  subDesctiprion: {
    ...baseConfig,
    fontSize: 12,
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    textAlign: 'right',
    color: 'grayText'
  },
  descriptionText: {
    ...baseConfig,
    fontSize: 16,
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'black.one'
  },
  tableHeader: {
    ...baseConfig,
    fontSize: 12,
    fontWeight: 'bold',
    fontStretch: 'normal',
    lineHeight: 1.67,
    letterSpacing: 'normal',
    color: 'black.one'
  },
  tableText: {
    ...baseConfig,
    fontSize: 16,
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'black.one'
  },
  pageSize: {
    ...baseConfig,
    fontSize: 12,
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'black.six'
  },
  accountPopupText: {
    ...baseConfig,
    fontSize: 16,
    fontWeight: 600,
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'black.six',
    textAlign: 'center'
  },
  addAccountLabels: {
    ...baseConfig,
    mixBlendMode: 'luminosity',
    fontSize: 14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    lineHeight: 1.14,
    letterSpacing: pxToRem('1.4px'),
    textAlign: 'center',
    color: 'white'
  },
  createAccountHeaders: {
    ...baseConfig,
    fontSize: 16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    lineHeight: 2,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'black.six'
  },
  resetFilterText: {
    ...baseConfig,
    fontSize: 12,
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    textAlign: 'right',
    color: 'grayText'
  },
  toast: {
    ...baseConfig,
    fontSize: 16,
    fontWeight: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.25,
    letterSpacing: 'normal'
  },
  resendEmailLabel: {
    ...baseConfig,
    mixBlendMode: 'luminosity',
    fontSize: 12,
    fontWeight: 'bold',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: pxToRem('1.2px'),
    textAlign: 'center',
    color: 'white'
  },
  peopleModalHeader: {
    ...baseConfig,
    fontSize: 24,
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'black.six'
  },
  peopleModalText: {
    ...baseConfig,
    fontSize: 16,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 2,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'black.six'
  },
  tooltipText: {
    ...baseConfig,
    fontSize: 14,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.14,
    letterSpacing: 'normal',
    color: 'black.six'
  },
  selectAllText: {
    ...baseConfig,
    fontSize: 12,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: pxToRem('2px'),
    color: 'black.six'
  },
  labelChart: {
    ...baseConfig,
    fontWeight: 'bold',
    color: 'lightGray2'
  },
  dashboardPartner: {
    ...baseConfig,
    fontSize: 24,
    fontWeight: 'bold',
    color: 'white',
    textTransform: 'uppercase',
    letterSpacing: pxToRem('3px')
  },
  leadCreationOptions: {
    ...baseConfig,
    textTransform: 'uppercase',
    fontSize: 16,
    letterSpacing: pxToRem('1px'),
    lineHeight: 1.5
  },
  addPhoneNumber: {
    ...baseConfig,
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: 1.14,
    textTransform: 'uppercase',
    letterSpacing: pxToRem('1.4px')
  },
  advancedSearch: {
    ...baseConfig,
    textTransform: 'uppercase',
    fontSize: 16,
    letterSpacing: pxToRem('1px'),
    lineHeight: 1.5,
    color: 'aquamarine',
    fontWeight: 'bold'
  },
  leadCsvUpload: {
    ...baseConfig,
    mixBlendMode: 'luminosity',
    fontWeight: 600,
    lineHeight: 1.71,
    fontStretch: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'black.one'
  }
};

const MainFont = ({ type, configuration, children }) => (
  <Typeface configuration={{ ...types[type], ...configuration }}>
    {children}
  </Typeface>
);

MainFont.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(Object.keys(types)),
  configuration: TypefaceInterface
};

MainFont.defaultProps = {
  type: '1'
};

export default MainFont;
